import React from 'react';
import ResourceConfigWizard from './components/ResourceConfigWizard';

const ResourceConfigurationRoute = () => <ResourceConfigWizard />;

export default ResourceConfigurationRoute;
